/**
 * Returns the complete users management state
 *
 * @param {object} state - Current state
 * @returns {object} - The entire banner notification state
 */
function getUsersInviteSignupState(state) {
  const toRet = {
    ...state.usersInviteSignup,
  };
  return toRet;
}

export default getUsersInviteSignupState;
